import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MediaCategory from 'src/config/MediaCategory';
import NewsList from 'src/pages/NewsList';
import withDisclaimer from 'src/utils/withDisclaimer';

export const getServerSideProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale, ['common', 'disclaimer'])),
        category: MediaCategory.NEWS,
    },
});

export default withDisclaimer()(NewsList);
